
import Components from "slotworks/components/components";
import SpinRecord from "slotworks/model/gameplay/records/spin-record";

export function SkipSpinCommand(spinRecord: SpinRecord) {
    return Components.matrix.skipTransition(spinRecord.stops, spinRecord.reelset, spinRecord.anticipations);
}



// WEBPACK FOOTER //
// ./~/slotworks/commands/comms/skip-spin-command.ts